
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class ProjectStatusSelect extends Vue {
    @Prop({type: Array, default: () => [{id: "All Clients", name: "All Clients"}]}) value!: DropdownOption[];

    statusOptions: DropdownOption[] = [{
      name: "Active Clients",
      id: "Active Clients",
    }, {
      name: "Completed Clients",
      id: "Completed Clients",
    },{
      name: "All Clients",
      id: "All Clients",
    }];

    handleInput(val: DropdownOption[]): void {
      if (!val.length) {
        return;
      }
      this.$emit("input", val);
    };
  }
